import { useContent } from '../../../../hooks/use-server-content';

export interface EmplifiFeedbackProps {
    hide: boolean;
    yesButtonLabel: string;
    noButtonLabel: string;
    feedbackTitle: string;
    commentBoxPlaceholder: string;
    sendButtonLabel: string;
    disclaimerLabel: string;
    thankYouLabel: string;
    errorMessage: string;
    feedbackTextTitle: string;
}
export const useEmplifiFeedbackValueContent = (): EmplifiFeedbackProps | null => {
    const [content, getValueByName] = useContent('emplifi', 'emplifi-feedback');
    let contentFragment: any = {};
    content?.elements.forEach(element => {
        contentFragment[`${element.name}`] = getValueByName(`${element.name}`);
    });
    if (contentFragment) {
        if (contentFragment.hide || !contentFragment.yesButtonLabel) {
            contentFragment = null;
        }
    }
    return contentFragment as EmplifiFeedbackProps;
};
